import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { Tab, Nav, Row, Col } from "react-bootstrap";
import { AuthContext } from '../../comum/Context/auth.jsx';
import { api } from '../../services/api.js';
import logoSmall from './../../comum/assets/arbor.png';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { formatInTimeZone, utcToZonedTime } from 'date-fns-tz';
import InputMask from 'react-input-mask';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../Utils/cropImage.js'; // função utilitária para gerar a imagem final (abaixo)
import './index.css';


function DadosFunc() {
  const navigate = useNavigate()
  const [nome, setNome] = useState('');
  const [admissao, setAdmissao] = useState('');
  const [dtadmissao, setDtAdmissao] = useState('');
  const [horario, setHorario] = useState('');
  const [codfilial, setCodFilial] = useState(0);
  const [loja, setLoja] = useState(0);
  const [secao, setSecao] = useState('');
  const [funcao, setFuncao] = useState('');
  const [cpf, setCpf] = useState(0);
  const [rg, setRg] = useState('');

  const [endereco, setEndereco] = useState('');
  const [numero, setNumero] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [complemento, setComplemento] = useState('');
  const [nascimento, setNascimento] = useState('');
  const [email, setEmail] = useState('');

  const [estado, setEstado] = useState('');
  const [codcep, setCodcep] = useState(0);
  const [tempo, setTempo] = useState(0);
  const [whatsapp, setWhatsApp] = useState('');
  const [fixo, setFixo] = useState('');
  const [contato, setContato] = useState('');
  const [salario, setSalario] = useState(0);
  const [foto, setFoto] = useState('');
  const [imagem, setImagem] = useState();
  const [tipo, setTipo] = useState('');
  const [valcelular, setValcelular] = useState('');
  const [valfixo, setValfixo] = useState('');
  const [valcontato, setValcontato] = useState('');
  const [valemail, setValemail] = useState('');
  const [valendereco, setValendereco] = useState('');


  //assistencia e convenio
  const [assistvalor, setAssistValor] = useState(0);
  const [assistlimite, setAssistLimite] = useState(0);
  const [assistdata, setAssistData] = useState('');
  const [assistfim, setAssistFim] = useState('');
  const [assistpend, setAssistPend] = useState(0);
  const [convstatus, setConvStatus] = useState('');
  const [convlimite, setConvLimite] = useState(0);
  const [convutilizado, setConvUtilizado] = useState(0);
  const [convsaldo, setConvSaldo] = useState(0);

  const chapa = localStorage.getItem("chapa");
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImagePreview, setCroppedImagePreview] = useState(null);


  const [eyesIsClosed, setEyeState] = useState(false);
  const [telefone, setTelefone] = useState("")
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '')
  const [show, setShow] = useState(false);
  const [mostrarSentimento, setMostrarSentimento] = useState(false);


  useEffect(() => {
    const chapa = localStorage.getItem("chapa");
    if (!chapa) {
      navigate("/arbor/login"); // Redireciona se não for funcionário logado
    }
  }, []);


  const phoneMask = (value) => {
    if (!value) return ""
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{2})(\d)/, "($1) $2")
    value = value.replace(/(\d)(\d{4})$/, "$1-$2")
    return value
  }


  function formatLeadingZero(text) {
    if (text.length === 13) {
      return `0${text}`;
    } else
      if (parseInt(text) < 100) {
        return `0${text}`;
      } else {
        return `${text}`;
      }
  }

  function CalculaIdade(dateString) {
    const date1 = new Date();
    const date2 = new Date(dateString);
    console.log(date1);
    console.log(date2);

    let anos = 0;
    let meses = 0;
    let dias = 0;

    // Calcular anos
    anos = date1.getFullYear() - date2.getFullYear();

    // Calcular meses
    meses = date1.getMonth() - date2.getMonth();
    console.log(meses);
    if (meses < 0) {
      anos--;
      meses += 12;
    }

    // Calcular dias
    dias = date1.getDate() - date2.getDate();

    if (dias < 0) {
      meses--;
      if (meses < 0) {
        anos--;
        meses += 12;
      }
      dias += new Date(date2.getFullYear(), date2.getMonth(), 0).getDate();
    }

    return `${anos} anos, ${meses} meses e ${dias} dias`;
  }



  const formatNumber = (amount, decimalCount = 2, decimal = ",", thousands = ".") => {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  }

  const MaskedInput = ({ value, onChange, name, mask, className }) => {
    function handleChange(event) {
      onChange({
        ...event,
        className,
        target: {
          ...event.target,
          name,
          value: onlyNumbers(event.target.value),
        }
      });
    };

    return (
      <InputMask
        name={name}
        mask={mask}
        value={value}
        onChange={handleChange}
        className="form-control fontmenor texto_centro"
        id="exampleInputcnpj"
        aria-describedby="emailHelp"
        disabled
      />
    );
  };



  useEffect(() => {
    setFoto('https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg');
    api.get('/usuario/dados/' + chapa
    )
      .then(async (retorno) => {
        await

          setNome(retorno.data[0].nome);
        setAdmissao(formatInTimeZone(retorno.data[0].dataadmissao.substring(0, 23), 'America/Sao_Paulo', "dd'/'MM'/'yyyy'"));
        setDtAdmissao(formatInTimeZone(retorno.data[0].dataadmissao.substring(0, 23), 'America/Sao_Paulo', "yyyy'/'MM'/'dd"));
        setHorario(retorno.data[0].deschorario);
        setCodFilial(retorno.data[0].codfilial);
        setLoja(retorno.data[0].loja);
        setSecao(retorno.data[0].secao);
        setFuncao(retorno.data[0].funcao);
        setCpf(retorno.data[0].cpf);
        setRg(retorno.data[0].rg);
        setSalario(retorno.data[0].salario)

        setEndereco(retorno.data[0].rua);
        setNumero(retorno.data[0].numero);
        setBairro(retorno.data[0].bairro);
        setCidade(retorno.data[0].cidade);
        setComplemento(retorno.data[0].complemento);
        setNascimento(formatInTimeZone(retorno.data[0].dtnascimento.substring(0, 23), 'America/Sao_Paulo', "dd'/'MM'/'yyyy'"));
        setEmail(retorno.data[0].email);

        setEstado(retorno.data[0].estado);
        setCodcep(retorno.data[0].cep);
        setTempo(retorno.data[0].tempo);
        setWhatsApp(retorno.data[0].telefone2);
        setFixo(retorno.data[0].telefone1);
        setContato(retorno.data[0].telefone3);

        setValcelular(retorno.data[0].usr_telefonecelular);
        setValcontato(retorno.data[0].usr_telefone3);
        setValfixo(retorno.data[0].usr_telefofixo);
        setValemail(retorno.data[0].usr_emailcheck);
        setValendereco(retorno.data[0].usr_endereco);

        //assitencia e convenio

        setAssistData(formatInTimeZone(retorno.data[0].assistdata.substring(0, 23), 'America/Sao_Paulo', "dd'/'MM'/'yyyy'"));
        setAssistFim(formatInTimeZone(retorno.data[0].assistfim.substring(0, 23), 'America/Sao_Paulo', "dd'/'MM'/'yyyy'"));
        setAssistLimite(retorno.data[0].assistlimite);
        setAssistPend(retorno.data[0].assistpend);
        setAssistValor(retorno.data[0].assistvalor);

        setConvLimite(retorno.data[0].convlimite);
        setConvSaldo(retorno.data[0].convsaldo);
        setConvStatus(retorno.data[0].convstatus);
        setConvUtilizado(retorno.data[0].convutilizado);

        BuscarFoto();
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function BuscarFoto() {
    api.get('/usuario/foto/' + chapa)
      .then(async (retorno) => {
        await
          setFoto('data:image/jpeg;base64,' + retorno.data.foto);
        setImagem();
      })
      .catch((err) => {
        console.log(err);
      });
  }


  async function gravarfoto() {
    try {
      const croppedUrl = await getCroppedImg(imagem, croppedAreaPixels);
      const response = await fetch(croppedUrl);
      const blob = await response.blob();

      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {
        const base64Image = reader.result;
        setImagem(base64Image);

        const data = {
          tipo,
          imagem: base64Image,
          loja,
        };

        await api.post('/usuario/foto/' + chapa, data);
        BuscarFoto();
      };
    } catch (err) {
      console.error(err);
      alert('Erro ao recortar imagem');
    }
  }

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      console.log('Imagem carregada:', reader.result);
      setImagem(reader.result);
    });
    reader.readAsDataURL(file);
  };

  const onCropComplete = async (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
    if (imagem) {
      try {
        const croppedUrl = await getCroppedImg(imagem, croppedAreaPixels);
        setCroppedImagePreview(croppedUrl);
      } catch (err) {
        console.error('Erro ao gerar preview:', err);
      }
    }
  };


  return <div>
    {/* */}
    <div className="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel">Alterar Foto</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setImagem(null); setCroppedImagePreview(null); }}></button>
          </div>
          <div className="modal-body">
            {imagem ? (
              <>
                <div style={{ position: 'relative', width: '100%', height: 300 }}>
                  <Cropper
                    image={imagem}
                    crop={crop}
                    zoom={zoom}
                    aspect={1}
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={onCropComplete}
                  />
                </div>
                {croppedImagePreview && (
                  <div className="text-center mt-3">
                    <p className="mb-1">Pré-visualização:</p>
                    <img
                      src={croppedImagePreview}
                      alt="Pré-visualização"
                      style={{ width: 120, height: 120, borderRadius: '50%', objectFit: 'cover', border: '2px solid #ccc' }}
                    />
                  </div>
                )}
              </>
            ) : (
              <img className="text-center fotoPerfil" alt="Foto" src={foto || 'https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg'} />
            )}
          </div>
          <div className="modal-footer">
            <input type="file" name="file" id="file" className="inputfile" onChange={handleChange} accept=".png,.jpg,.jpeg" />
            <label htmlFor="file" className="btn btn-dark">
              <i className="fa fa-search" aria-hidden="true"></i> Buscar foto
            </label>
            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={() => { setImagem(null); setCroppedImagePreview(null); }}>
              <i className="fa fa-ban" aria-hidden="true"></i> Cancelar
            </button>
            {imagem && (
              <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={gravarfoto}>
                <i className="fa fa-check-circle" aria-hidden="true"></i> Alterar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
    {/* */}
    <div>
      <Menu modulo="ARBOR" />
      <div className="container-fluid pagina-dados">
        <div className="offset-lg-3 col-lg-6">

          <form className="form-control-sm">
            <div className="row">
              <div className="fotoabs">
                <img className="img-center circle text-center" alt="Foto" data-bs-toggle="modal" data-bs-target="#exampleModal" src={foto ? foto : "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg"} />
                <span className="botaoflutuante">
                  <button type="button" className="btn btn-sm btn-danger botaoflutuante" data-bs-toggle="modal" data-bs-target="#exampleModal" data-bs-whatever=""> <i className="fa fa-camera" aria-hidden="true"></i></button>

                </span>
              </div>
              <div className="col-xl-3 col-lg-3 col-3 ">
                <label className="form-label">Chapa</label>
                <input type="text" value={chapa} className="form-control fontmenor texto_centro" id="exampleInputid" aria-describedby="emailHelp" disabled />
              </div>
              <div className="col-xl-5 col-lg-5 col-5">
                <label className="form-label">CPF</label>
                <MaskedInput className="fontmenor" type="text" name="cnpj" mask="999.999.999-99" value={formatLeadingZero(cpf)} />
              </div>
              <div className="col-xl-2 col-lg-2 col-2">
                <label className="form-label"><i className="fa fa-location-arrow"></i> Lj</label>
                <input type="text" value={formatLeadingZero(loja)} className="form-control fontmenor texto_centro" id="exampleInputerp" aria-describedby="emailHelp" disabled />
              </div>
              <div className="col-xl-2 col-lg-2 col-2">
                <label className="form-label"><i className="fa fa-location-arrow"></i> Fl</label>
                <input type="text" value={formatLeadingZero(codfilial)} className="form-control fontmenor texto_centro" id="exampleInputerp" aria-describedby="emailHelp" disabled />
              </div>

              <div className="col-xl-12 col-lg-12 col-12">
                <label className="form-label">Nome</label>
                <input type="text" value={nome} className="form-control fontmenor" id="exampleInputerp" aria-describedby="emailHelp" disabled />
              </div>

              <div className="col-xl-6 col-lg-6 col-6 ">
                <label className="form-label"><i className="fa fa-calendar"></i> Nascimento</label>
                <input type="text" value={nascimento} className="form-control fontmenor texto_centro" id="exampleInputid" aria-describedby="emailHelp" disabled />
              </div>
              <div className="col-xl-6 col-lg-6 col-6">
                <label className="form-label"><i className="fa fa-calendar"></i> Admissão</label>
                <input type="text" value={admissao} className="form-control fontmenor texto_centro" id="exampleInputid" aria-describedby="emailHelp" disabled />
              </div>

              <div className="col-xl-12 col-lg-12 col-12  texto_centro ">
                <label className="form-label font-espaco">Tempo de Empresa: {CalculaIdade(dtadmissao)}</label>
              </div>


              <div className="col-xl-5 col-lg-5 col-5 ">
                <label className="form-label">Seção</label>
                <input type="text" value={secao} className="form-control fontmenor" id="exampleInputid" disabled />
              </div>
              <div className="col-xl-4 col-lg-4 col-4 ">
                <label className="form-label">Função</label>
                <input type="text" value={funcao} className="form-control fontmenor " id="exampleInputerp" disabled />
              </div>
              <div className="col-xl-3 col-lg-3 col-3">
                <label className="form-label">Salario</label>
                <input type="text" value={formatNumber(salario)} className="form-control fontmenor texto_direita" id="exampleInputerp" disabled />
              </div>

              {/*ENDERECO*/}
              <div className="col-xl-10 col-lg-10 col-10 hr2">
                <label className="form-label">Endereço {valendereco === 'S' ? <i className="bi bi-patch-check-fill cor-azul"> </i> : <i className="bi bi-patch-check-fill cor-cinza"> </i>}</label>
                <input type="text" value={endereco} className="form-control fontmenor" id="exampleInputid" disabled />
              </div>
              <div className="col-xl-2 col-lg-2 col-2 hr2">
                <label className="form-label">Nº.</label>
                <input type="text" value={numero} className="form-control fontmenor texto_direita" id="exampleInputerp" disabled />
              </div>

              <div className="col-xl-8 col-lg-8 col-8 ">
                <label className="form-label">Complemento</label>
                <input type="text" value={complemento} className="form-control fontmenor" id="exampleInputid" disabled />
              </div>
              <div className="col-xl-4 col-lg-4 col-4">
                <label className="form-label">Cep</label>
                <MaskedInput type="text" name="cep" mask="99.999-999" value={formatLeadingZero(formatLeadingZero(codcep))} className="fontmenor" />
              </div>

              <div className="col-xl-6 col-lg-6 col-6 ">
                <label className="form-label">Bairro</label>
                <input type="text" value={bairro} className="form-control fontmenor" id="exampleInputid" disabled />
              </div>
              <div className="col-xl-4 col-lg-4 col-4">
                <label className="form-label">Cidade</label>
                <input type="text" value={cidade} className="form-control fontmenor" id="exampleInputerp" disabled />
              </div>
              <div className="col-xl-2 col-lg-2 col-2 ">
                <label className="form-label">UF</label>
                <input type="text" value={estado} className="form-control fontmenor texto_centro" id="exampleInputid" disabled />
              </div>



              {/*CONTATO*/}
              <div className="col-xl-4 col-lg-4 col-4 hr2">
                <label htmlFor="exampleInputEmail1" className="form-label"><i className="bi bi-whatsapp cor-icon"></i> Whats {valcelular === 'S' ? <i className="bi bi-patch-check-fill cor-azul"> </i> : <i className="bi bi-patch-check-fill cor-cinza"> </i>}</label>
                <input type="text" value={phoneMask(whatsapp)} className="form-control fontmenor texto_centro" id="handlePhone" aria-describedby="" disabled></input>
              </div>
              <div className="col-xl-4 col-lg-4 col-4 hr2">
                <label className="form-label"><i className="fa fa-phone cor-icon"></i> Fixo {valfixo === 'S' ? <i className="bi bi-patch-check-fill cor-azul"> </i> : <i className="bi bi-patch-check-fill cor-cinza"> </i>}</label>
                <input type="text" value={phoneMask(fixo)} className="form-control fontmenor texto_centro" id="exampleInputerp" disabled />
              </div>
              <div className="col-xl-4 col-lg-4 col-4 hr2">
                <label className="form-label"><i className="fa fa-phone-square"></i> Contato {valcontato === 'S' ? <i className="bi bi-patch-check-fill cor-azul"> </i> : <i className="bi bi-patch-check-fill cor-cinza"> </i>}</label>
                <input type="text" value={phoneMask(contato)} className="form-control fontmenor texto_centro" id="exampleInputerp" disabled />
              </div>

              <div className="col-xl-12 col-lg-12 col-12">
                <label className="form-label"><i className="fa fa-envelope"></i> E-mail {valemail === 'S' ? <i className="bi bi-patch-check-fill cor-azul"> </i> : <i className="bi bi-patch-check-fill cor-cinza"> </i>}</label>
                <input type="text" value={email} className="form-control fontmenor" id="exampleInputerp" disabled />
              </div>


              {/*ASSISTÊNCIA*/}

              <div className="col-xl-12 col-lg-12 col-12 hr2 texto_centro">
                <label className="form-label">Assistência AEFLOR</label>
              </div>

              <div className="col-xl-2 col-lg-2 col-6 ">
                <label className="form-label"><i className="fa fa-money cor-icon"></i> Limite</label>
                <input type="text" value={formatNumber(assistlimite)} className="form-control fontmenor texto_centro" id="handlePhone" aria-describedby="" disabled></input>
              </div>

              <div className="col-xl-2 col-lg-2 col-6">
                <label className="form-label"><i className="fa fa-spinner"></i> Pendente </label>
                <input type="text" value={formatNumber(assistpend)} className="form-control fontmenor texto_centro" id="exampleInputerp" disabled />
              </div>
              <div className="col-xl-2 col-lg-2 col-4">
                <label className="form-label"><i className="fa fa-money cor-icon"></i> Última</label>
                <input type="text" value={formatNumber(assistvalor)} className="form-control fontmenor texto_centro" id="handlePhone" aria-describedby="" disabled></input>
              </div>
              <div className="col-xl-3 col-lg-3 col-4">
                <label className="form-label"><i className="fa fa-calendar"></i> Data </label>
                <input type="text" value={assistdata} className="form-control fontmenor texto_centro" id="exampleInputerp" disabled />
              </div>
              <div className="col-xl-3 col-lg-3 col-4">
                <label className="form-label"><i className="fa fa-calendar"></i> Prazo </label>
                <input type="text" value={assistfim} className="form-control fontmenor texto_centro" id="exampleInputerp" disabled />
              </div>

              {/*CONVÊNIO AEFLOR*/}

              <div className="col-xl-12 col-lg-12 col-12 hr2 texto_centro">
                <label className="form-label">Convênio AEFLOR</label>
              </div>

              <div className="col-xl-3 col-lg-3 col-3 ">
                <label className="form-label"><i className="fa fa-info cor-icon"></i> Status</label>
                <input type="text" value={convstatus === 'L' ? 'LIBERADO PARA COMPRA' : 'BLOQUEADO PARA COMPRA'} className="form-control fontmenor texto_centro" id="handlePhone" aria-describedby="" disabled></input>
              </div>

              <div className="col-xl-3 col-lg-3 col-3">
                <label className="form-label"><i className="fa fa-money"></i> Limite </label>
                <input type="text" value={formatNumber(convlimite)} className="form-control fontmenor texto_centro" id="exampleInputerp" disabled />
              </div>
              <div className="col-xl-3 col-lg-3 col-3">
                <label className="form-label"><i className="fa fa-money cor-icon"></i> Util.</label>
                <input type="text" value={formatNumber(convutilizado)} className="form-control fontmenor texto_centro" id="handlePhone" aria-describedby="" disabled></input>
              </div>
              <div className="col-xl-3 col-lg-3 col-3">
                <label className="form-label"><i className="fa fa-money"></i> Saldo </label>
                <input type="text" value={formatNumber(convsaldo)} className="form-control fontmenor texto_centro" id="exampleInputerp" disabled />
              </div >
            </div >


            {/*<label className="form-label col-xl-12 col-lg-12 col-12 hr2"><i className="bi bi-cake2-fill"> Aniversariantes</i></label>
            <Aniversario />*/}
          </form>

        </div>

        <br></br>
        <Footer className="footer navbar-fixed-bottom" />
      </div>

    </div >


  </div >

}

export default DadosFunc;
